import React from 'react';
import {
  MenuItem,
  Select,
  SelectType,
  Typography,
  TypographyType,
  TypographyVariant,
} from '../../../../../../../components-dummy';

interface Props {
  data: string[];
  field: string;
  defaultValue: string;
  value: string;
  onChange: (field: string, value: any) => void;
  label?: string;
}

export const DropdownStyle = ({ data, field, defaultValue, value, onChange, label }: Props) => {
  const options = data.map(option => {
    return {
      value: option,
      text: option,
    };
  });
  const handleChange = e => onChange(field, e.target.value);

  return (
    <>
      {label && (
        <Typography variant={TypographyVariant.MediumRegular} type={TypographyType.Body}>
          {label}
        </Typography>
      )}
      <Select type={SelectType.Menu} onChange={handleChange} value={value || defaultValue}>
        {options.map((option: { value: string; text: string }) => (
          <MenuItem key={option.value} value={option.value}>
            {option.text}
          </MenuItem>
        ))}
      </Select>
    </>
  );
};
